import React from 'react';
import Rent from './rent';
import request from '../../../service/request';
import { RENTHOUSE_GET_DETAIL, RENTHOUSE_GET_MAINMAINTAIN, ONLINE_STORE_POST } from '../../../service/api';

async function action ({ query, cookie }) {
    if(query.id) {
        const [houseData, agentData] = await Promise.all([
            request.GET({
                url: RENTHOUSE_GET_DETAIL + query.id,
                headers: cookie ? {
                    cityCode: cookie['cityCode'] || 420200
                } : {}
            }),
            request.GET({
                url: RENTHOUSE_GET_MAINMAINTAIN + query.id,
                headers: cookie ? {
                    cityCode: cookie['cityCode'] || 420200
                } : {}
            })
        ]);

        if(houseData.code != 0) {
            return
        }

        if(!houseData.data.latitude || !houseData.data.longitude){
            houseData.data.latitude = '31.299758'
            houseData.data.longitude = '120.585294'
        }

        let shopQr = null;
        // if (agentData.data) {
        //     shopQr = await request.POST({
        //         url: ONLINE_STORE_POST,
        //         params: {
        //             page: 'pages/share/index',
        //             targetPage: '/pages/home/index',
        //             width: '400',
        //             scene: `shopId=${agentData.data.shopId}`
        //         },
        //         headers: cookie ? {
        //             cityCode: cookie['cityCode'] || 420200
        //         } : {}
        //     });
        // }

        const pData = {
            id: query.id || '',
            houseInfo: houseData.data || null,
            viewerImgList: houseData.data ? houseData.data.roomImage : [],
            pageCode: houseData.code,
            agent: agentData.data,
            shopQr: shopQr ? shopQr.data : ''
        }

        return {
            title: pData.houseInfo ? `${pData.houseInfo.houseName}_东楚优房` : '东楚优房',
            chunks: ['rent'],
            component: (
                <Rent pagedata={pData} />
            )
        };
    }
}
export default action;
